var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01511 21V19H19.0151V21H5.01511ZM12.0151 17C10.3318 17 9.02344 16.475 8.09011 15.425C7.15677 14.375 6.69011 12.9833 6.69011 11.25V3H9.26511V11.4C9.26511 12.3333 9.49844 13.0917 9.96511 13.675C10.4318 14.2583 11.1151 14.55 12.0151 14.55C12.9151 14.55 13.5984 14.2583 14.0651 13.675C14.5318 13.0917 14.7651 12.3333 14.7651 11.4V3H17.3401V11.25C17.3401 12.9833 16.8734 14.375 15.9401 15.425C15.0068 16.475 13.6984 17 12.0151 17Z",
    fill: "#343F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorUnderline);
export default __webpack_public_path__ + "static/media/editor-underline.c6d082d171df41fbe765503d1d57e8ad.svg";
export { ForwardRef as ReactComponent };